module.exports = __webpack_public_path__ + "img/2.4b48798b.png";